module.exports = __webpack_public_path__ + "static/media/130.a0038b94.png";